import React from 'react';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/undraw-workout-gcgu.svg';

export const WhatIsFlexibilityStep = () => (
    <>
        <S.ContentRow>
            <S.ContentColumn>
                <S.StepHeading small>Flexibility</S.StepHeading>
                <S.StepHeading>What is Psychological Flexibility?</S.StepHeading>
            </S.ContentColumn>
        </S.ContentRow>
        <S.ContentRow>
            <S.ContentColumn md={14}>
                <S.StepDescription small>
                    It's not always easy to live according to our values. Sometimes things get in
                    the way. These can be things that are external to us (e.g., it rains and we
                    don't take that walk we were planning on), or things that are internal to us
                    (e.g., we plan to go for a walk but we decide to watch TV instead). Often the
                    things that get in the way are our thoughts (e.g. “I’m too tired to go for a
                    walk”), or our emotions (e.g., stress, worry).
                </S.StepDescription>
                <S.StepDescription small>
                    Psychological flexibility is being able to mindfully notice what comes up, and
                    choose how you want to respond. For example, if it rains when you planned to
                    take a walk, can you do yoga instead, or schedule it for the next day it’s
                    sunny, or grab an umbrella and go stomp around in the rain?
                </S.StepDescription>
                <S.StepDescription small>
                    Flexibility also means cutting ourselves some slack if we don't live according
                    to our values all the time.
                </S.StepDescription>
            </S.ContentColumn>
            <S.ContentColumn md={10}>
                <S.StepIcon iconUrl={stepIcon} />
            </S.ContentColumn>
        </S.ContentRow>
    </>
);
